export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q04_a.f413e53b.png";